/**
 * BRAND.md §5: pill, radius 14px, Montserrat 700 at 12px, optional 7px status
 * dot in the text colour.
 */

import { statusHelp, statusStyle, TONE_CLASSES, type Tone } from '../status'
import { Tooltip } from './Tooltip'

/**
 * `kind` turns on the hover help saying what the status means. It is opt-in
 * and never a tab stop: the badge repeats on every row of a long table.
 */
export function StatusBadge({ status, kind }: { status: string; kind?: 'obligation' | 'job' }) {
  const { label, tone } = statusStyle(status)
  const badge = <Badge tone={tone}>{label}</Badge>
  if (kind === undefined) return badge
  return (
    <Tooltip content={statusHelp(status, kind)} focusable={false}>
      {badge}
    </Tooltip>
  )
}

export function Badge({ tone, children }: { tone: Tone; children: React.ReactNode }) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-eq-pill px-2.5 py-1',
        'font-heading text-[12px] font-bold',
        TONE_CLASSES[tone],
      ].join(' ')}
    >
      <span className="h-[7px] w-[7px] rounded-full bg-current" aria-hidden />
      {children}
    </span>
  )
}
